// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLE_ADD_EXPERIENCE_TITLE = "Pridaj svoju sk\u00fasenos\u0165";
export const ARTICLE_EXPERIENCE_SEND = "Odo\u0161li";
export const SEO_TITLE_WIKI_ARTICLE_ADD_EXPERIENCE = "Pridaj svoju sk\u00fasenos\u0165";
export const WIKI_EXP_DRAFT_SAVE_AS_DRAFT = "Ulo\u017e ako draft";
